export default __webpack_public_path__ + "static/media/tank-model.168c750f.jpg";